import API from "../global/api";

// Getting Project List
export const getClientListRequest = () => {
  return {
    type: "CLIENT_LIST_REQUEST",
  };
};
export const getClientListSuccess = (data) => {
  return {
    type: "CLIENT_LIST_SUCCESS",
    payload: data,
  };
};
export const getClientListError = (msg) => {
  return {
    type: "CLIENT_LIST_ERROR",
    payload: msg,
  };
};
export const getClientList = () => {
  return (dispatch) => {
    dispatch(getClientListRequest());
    API.get(`/user/get-projects`)
      .then((res) => {
        let clientDetails = res.data.projects;
        dispatch(getClientListSuccess(clientDetails));
      })
      .catch((error) => {
        dispatch(getClientListError(error.response.data.message));
      });
  };
};

// Edit Client List
export const editClientRequest = () => {
  return {
    type: "EDIT_CLIENT_REQUEST",
  };
};
export const editClientSuccess = (data) => {
  return {
    type: "EDIT_CLIENT_SUCCESS",
    payload: data,
  };
};
export const editClientError = (msg) => {
  return {
    type: "EDIT_CLIENT_ERROR",
    payload: msg,
  };
};
export const editClient = (id, data) => {
  return (dispatch) => {
    dispatch(editClientRequest());
    API.post(`/user/update-project-expiry/${id}`, data)
      .then((res) => {
        let data1 = res.data;
        dispatch(editClientSuccess(data1));
        dispatch(getClientList());
      })
      .catch((error) => {
        dispatch(editClientError(error.response.data.message));
      });
  };
};
